// 内蒙古亿达电子招采平台
export default {
    nav: [
        {
            title: '首页',
            href: '/',
            activeReg: /(^\/search*)|(^\/$)/,
        },
        {
            title: '新闻公告',
            href: '/news',
            activeReg: /(^\/news*)/,
        },
        {
            title: '交易信息',
            href: '/business',
            activeReg: /(^\/business*)/,
        },
        {
            title: '帮助中心',
            href: '/guide',
            activeReg: /(^\/guide*)/,
        },
        {
            title: '下载中心',
            href: '/download',
            activeReg: /(^\/download*)/,
        },
        {
            title: 'CA办理/续费',
            href: '/cahandle',
            activeReg: /(^\/cahandle*)/,
        },
        {
            title: '关于我们',
            href: '/about',
            activeReg: /(^\/about*)/,
        },
    ],
    head: {
        title: '内蒙古亿达电子招采平台',//全称
        title2: '亿达招采',//简称
        jc_title: '亿达招采',//简称
        citycode:'150000',//城市编号
        planName:'yida',
        caType:'yidacaapply',
        caHref:'http://online.nmgca.com:8880/?CAQYDZ=mdyzc',//CA申请链接
        meta: {
            description: '内蒙古亿达电子招采平台,交易平台,招投标,电子交易平台',
            keywords: '内蒙古亿达电子招采平台,交易平台,招投标,电子交易平台',
        },
        favicon: '/yida/favicon.ico',
        logoUrl: '/yida/images/logo.png',//首页LOGO
        loginImgUrl: '',
        registerImg: '/yida/images/registerLogo.png',//注册页面LOGO
        bannerList:[
            {
                linkimg:'',
                linkurl:''
            }
        ],
        tbLoginUrl:'',
        isNotZfcg: true,//没有政府采购
        // 用户角色登录
        userRoles: [
            {
                imgsrc: '/img/hzzlogin/zb.png',
                href: 'http://dl.nmydzb.ltd/otc/#/login?plan=yida&mRole=agent',
                title: '代理机构登录',
                class: 'gcjs',
            },
            {
                imgsrc: '/img/hzzlogin/tb.png',
                href: 'http://tb.nmydzb.ltd/#/login?plan=yida',
                title: '供应商登录',
                class: 'zfcg',
            },
            {
                imgsrc: '/img/hzzlogin/pb.png',
                href: 'http://pb.nmydzb.ltd/?plan=yida',
                title: '专家登录',
                class: 'zj'
            },
            {
                imgsrc: '/img/hzzlogin/cg.png',
                href: 'http://dl.nmydzb.ltd/otc/#/login?plan=yida&mRole=tender',
                title: '采购人登录',
                class: 'qycg',
            },
        ],
        friendLinks:[
            {
                href: 'http://www.cebpubservice.com/',
                title: '中国招投标公共服务平台'
            },
            {
                href: 'http://www.ccgp.gov.cn/',
                title: '中国政府采购网'
            },
            {
                href: 'https://www.creditchina.gov.cn/',
                title: '信用中国'
            },
            {
                href: 'https://wenshu.court.gov.cn/',
                title: '中国裁判文书网'
            },
            {
                href: '',
                title: ''
            },
            {
                href: '',
                title: ''
            },
        ],
        tel: '400-901-6886', //客服电话
        tel2: '0471-6306699',//备用电话/其他电话
        telSeparate:true,//客服电话 和 备用联系电话分隔开 ，不用同一个
        fax: '',//传真号码
        email: 'nmgydzbdl@163.com', //邮箱地址
        workTime: '',//工作时间
        postalCode: '',//邮政编码
        companyName: '内蒙古亿达招标代理有限公司',  //运营公司名称
        companyAddress: '内蒙古自治区呼和浩特市赛罕区滨河路水岸小镇四区13号楼四区102号底商',//公司地址
        companyLatLng:{ lng: 0, lat: 0 },//公司地址坐标
        showWeather: false,//是否显示天气
        icp:'蒙ICP备2025029918号-1',
        gwIcp:'',
        products: [
            {
                title: 'xxxx',
                href: 'xxxxx'
            },
        ],
        isHiddenZiRanRen: false, //注册页面 用户类型是否隐藏自然人
        isCheckOtherSingleCertCode: true, //注册页面 是否校验 其他一证一照代码
    },
    proxy: {
        '/web': {
            target: 'http://www.nmydzb.ltd/',
            changeOrigin:true,
        },
    },
}